import { useEffect, useState } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { RUNTIME_BACKEND_URL } from '../../lib/backendUrl';
import { isNative } from '../../lib/mobile';

const cache = {};

export const useAuthConfig = (apiBase) => {
  const [cfg, setCfg] = useState(cache[apiBase] || null);
  useEffect(() => {
    if (cache[apiBase]) return;
    fetch(`${RUNTIME_BACKEND_URL}${apiBase}/google-config`).then(r => r.json())
      .then(d => { cache[apiBase] = d; setCfg(d); }).catch(() => setCfg({ client_id: '', mail_enabled: false }));
  }, [apiBase]);
  return cfg;
};

// Google ile giriş / hesap bağlama butonu (mobil uygulama WebView'ında Google izin vermediği için gizlenir)
export const GoogleAuthButton = ({ apiBase, onCredential, text = 'continue_with', theme = 'outline', testId = 'google-auth-btn' }) => {
  const cfg = useAuthConfig(apiBase);
  if (!cfg?.client_id || isNative()) return null;
  return (
    <div className="flex justify-center" data-testid={testId}>
      <GoogleOAuthProvider clientId={cfg.client_id}>
        <GoogleLogin
          onSuccess={(r) => onCredential(r.credential)}
          onError={() => {}}
          text={text} theme={theme} shape="pill" locale="tr" width="320"
        />
      </GoogleOAuthProvider>
    </div>
  );
};

export const OrDivider = ({ dark }) => (
  <div className="flex items-center gap-3 my-4">
    <div className={`flex-1 h-px ${dark ? 'bg-white/10' : 'bg-border'}`} />
    <span className={`text-[11px] uppercase tracking-wider ${dark ? 'text-slate-500' : 'text-muted-foreground'}`}>veya</span>
    <div className={`flex-1 h-px ${dark ? 'bg-white/10' : 'bg-border'}`} />
  </div>
);
